document.addEventListener("DOMContentLoaded", function () {
  document.body.addEventListener("click", function (event) {
    const item = event.target.closest(".product_stitching_item_card");
    if (!item) return;

    event.preventDefault();

    const productHandle = item.dataset.productHandle;
    const card = item.closest(".product-card-link");
    const blockId = card?.dataset.blockId;
    if (!card || !productHandle) return;
    fetch(`${productHandle}?view=product_card_template`)
      .then((res) => res.text())
      .then((htmlString) => {
        const parser = new DOMParser();
        const doc = parser.parseFromString(htmlString, "text/html");
        const newCard = doc.querySelector(".product-card-link");

        if (newCard) {
          card.replaceWith(newCard); // replaces the full card (DOM node and all)
        } else {
          console.warn("Updated product card not found");
        }
      })
      .catch((err) =>
        console.error("Error fetching stitched product card:", err)
      );
  });

  document.body.addEventListener('mouseenter', function (event) {
    const swatchFieldset = event.target.closest('.page-type-product');
    const textLabelHTML = document.getElementById('pdp-label-color-name');
    const textDefaultLabelHTML = document.getElementById('pdp-label-color-name-first')?.textContent;
    if (!swatchFieldset) return;
    if (!textLabelHTML) return;
    if (event.target.matches('.product_stitching_item input')) {
      textLabelHTML.textContent = event.target.dataset.colorName;
    } else if (!event.target.closest('.product_stitching_item')) {
      textLabelHTML.textContent = textDefaultLabelHTML;
    }
  }, true);
});
